import React, { useContext } from 'react';
import userContext from '../../components/ContextComponent/UserContext';

function Journey4() {
    const { formData } = useContext(userContext);
    return (
    <div>
            Thanks {formData.firstName} for applying! We will need further information to process your application.
    </div>
    );
}
export default Journey4;